const steps = [
  {
    number: "01",
    icon: "ri-user-add-line",
    title: "Cadastro Rápido",
    desc: "Você se cadastra em minutos com seus dados básicos. Sem burocracia, sem papelada desnecessária.",
    color: "bg-primary-700",
  },
  {
    number: "02",
    icon: "ri-bank-card-line",
    title: "Análise de Crédito na Hora",
    desc: "Realizamos a análise de crédito imediatamente e você já sabe como pode parcelar seu tratamento.",
    color: "bg-secondary",
  },
  {
    number: "03",
    icon: "ri-stethoscope-line",
    title: "Avaliação com Dentista",
    desc: "Nosso dentista realiza uma avaliação completa e apresenta o plano de tratamento personalizado.",
    color: "bg-primary-700",
  },
  {
    number: "04",
    icon: "ri-heart-pulse-line",
    title: "Tratamento Imediato",
    desc: "Com tudo aprovado, você já começa o tratamento na mesma visita. Sem esperas desnecessárias.",
    color: "bg-secondary",
  },
];

export default function HowItWorksSection() {
  return (
    <section id="como-funciona" className="py-16 md:py-24 bg-primary-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="text-secondary font-semibold text-sm uppercase tracking-widest">Processo Simples</span>
          <h3 className="text-3xl md:text-4xl font-extrabold text-primary-700 mt-3 mb-4">
            Como Funciona?
          </h3>
          <p className="text-gray-500 max-w-lg mx-auto text-base">
            Do cadastro ao início do tratamento, tudo acontece de forma rápida e sem complicações.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 relative">
          {/* Connector line */}
          <div className="hidden md:block absolute top-12 left-1/4 right-1/4 h-0.5 bg-gradient-to-r from-primary-200 via-secondary-200 to-primary-200 translate-x-[12.5%] w-3/4 mx-auto z-0"></div>

          {steps.map((step, idx) => (
            <div
              key={step.number}
              className="relative z-10 bg-white rounded-2xl p-4 md:p-6 text-center border border-gray-100 hover:border-primary-200 transition-all flex sm:block items-start gap-4"
              style={{ animationDelay: `${idx * 0.1}s` }}
            >
              <div className={`w-12 h-12 md:w-16 md:h-16 flex-shrink-0 flex items-center justify-center ${step.color} rounded-2xl text-white sm:mx-auto mb-0 sm:mb-4 md:mb-5 text-xl md:text-2xl`}>
                <i className={step.icon}></i>
              </div>
              <div className="text-left sm:text-center">
                <span className="text-xs font-bold text-gray-300 uppercase tracking-widest">{step.number}</span>
                <h4 className="text-sm md:text-base font-bold text-primary-700 mt-1 mb-1 md:mb-3">{step.title}</h4>
                <p className="text-gray-500 text-xs md:text-sm leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Payment highlight */}
        <div className="mt-8 md:mt-12 bg-gradient-to-r from-primary-700 to-primary-600 rounded-2xl p-5 md:p-8 flex flex-col md:flex-row items-center justify-between gap-5 md:gap-6">
          <div className="flex items-center gap-4 md:gap-5 w-full md:w-auto">
            <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-white/20 rounded-xl text-white text-2xl flex-shrink-0">
              <i className="ri-percent-line"></i>
            </div>
            <div>
              <h4 className="text-white font-bold text-base md:text-xl">Pagamento Facilitado</h4>
              <p className="text-white/70 text-xs md:text-sm mt-1">
                Parcelamos em até 24x com aprovação imediata. Condições especiais para toda a família.
              </p>
            </div>
          </div>
          <div className="flex gap-3 md:gap-4 w-full md:w-auto justify-between md:justify-end">
            <div className="flex-1 md:flex-none bg-white/10 border border-white/20 rounded-xl px-3 md:px-5 py-2.5 md:py-3 text-center">
              <p className="text-secondary-300 font-extrabold text-xl md:text-2xl">24x</p>
              <p className="text-white/70 text-xs">Parcelas</p>
            </div>
            <div className="flex-1 md:flex-none bg-white/10 border border-white/20 rounded-xl px-3 md:px-5 py-2.5 md:py-3 text-center">
              <p className="text-secondary-300 font-extrabold text-xl md:text-2xl">0%</p>
              <p className="text-white/70 text-xs">Entrada</p>
            </div>
            <div className="flex-1 md:flex-none bg-white/10 border border-white/20 rounded-xl px-3 md:px-5 py-2.5 md:py-3 text-center">
              <p className="text-secondary-300 font-extrabold text-xl md:text-2xl">100%</p>
              <p className="text-white/70 text-xs">Aprovado</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
